// ==============================|| OVERRIDES - LINK ||============================== //

export default function Link() {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover'
      },
      styleOverrides: {
        root: {
          color: '#1890FF',
          textDecoration: 'none',
          '&:visited': {
            color: '#1890FF'
          },
          '&:hover': {
            color: '#1890FF'
          },
          '&:active': {
            color: '#1890FF'
          }
        }
      }
    }
  };
}
